import {
  Component,
  DoCheck,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ResultStatus } from "@app/core/models/result-status";
import { WINDOW } from "@app/core/providers/window.provider";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { CommunityService } from "@app/core/services/community.service";
import { HelperService } from "@app/core/services/helper.service";
import { AppConfig } from "@app/core/Utilities/app-config.service";
import { AgentDetailComponent } from "@app/modules/agent/pages/agent-detail/agent-detail.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { PostReferralComponent } from "../post-referral/post-referral.component";
import { ShareUpdateComponent } from "../share-update/share-update.component";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import * as _ from "lodash";
import { NgxLinkifyjsService } from 'ngx-linkifyjs';

@Component({
  selector: "app-post-item-detail",
  templateUrl: "./post-item-detail.component.html",
  styleUrls: ["./post-item-detail.component.scss"],
})
export class PostItemDetailComponent implements OnInit, DoCheck, OnDestroy {
  @ViewChild("shareUrlTemplate") shareUrlTemplate: ElementRef;
  @ViewChild("videoPlayer") videoplayer: ElementRef;
  @ViewChild("deleteMessageTemplate") deleteMessageTemplate: ElementRef;
  @ViewChild("autosize") autosize: CdkTextareaAutosize;
  public displayHeader = false;

  commentText = "";
  currentDate = new Date();
  postDetail: any;
  commentList = [];
  throttle = 300;
  scrollDistance = 0;
  scrollUpDistance = 0;
  postId: any;
  bsModalRef: BsModalRef;
  isDeleteAllow = false;
  isEditable = false;
  isReportAllow = false;
  isApprovedRejectAllow = false;
  loginUserID: any;
  shareUrl;
  baseShareUrl = "community/post/detail/";
  selectedGroupId: any;
  selectedTag: "";
  selectedfeedId: any;
  public tags = [];
  links: any[];
  postLink: any[];
  hasLink: boolean;
  isDataLoaded = false;

  constructor(
    @Inject(WINDOW) private window: Window,
    private communityService: CommunityService,
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private toaterService: ToastrService,
    private modalService: BsModalService,
    private sanit: DomSanitizer,
    private authService: AuthenticationService,
    private router: Router,
    public appConfig: AppConfig,
    private linkifyService: NgxLinkifyjsService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.postId = param.id;
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.groupId)) {
        this.selectedGroupId = params.groupId;
      }
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.tag)) {
        this.selectedTag = params.tag;
      }
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.feedId)) {
        this.selectedfeedId = params.feedId;
      }
    });
  }

  ngOnInit() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.postId)) {
      this.getPostById();
    }
  }

  ngDoCheck() {
    if (this.postDetail) {
      if (this.appConfig.SharedComponent.loggedInUserInfo !== null) {
        this.isDeleteAllow =
          this.postDetail.CreatedBy === this.loginUserID ||
          this.isModeratorGroupAdmin(this.postDetail.GroupId);
        this.isApprovedRejectAllow =
          this.isModeratorGroupAdmin(this.postDetail.GroupId) && this.postDetail.IsHidden === true;
        this.isReportAllow = !this.isModeratorGroupAdmin(this.postDetail.GroupId) && this.postDetail.CreatedBy !== this.loginUserID;
      }
    }
  }

  resetSize() {
    if (!this.commentText) {
      this.autosize.resizeToFitContent(true);
    }
  }

  splitTags() {
    this.tags = _.split(this.postDetail.Tag, "#");
  }

  backToList(tag) {
    this.selectedTag = tag;
    this.back();
  }

  back() {
    this.router.navigate([
      `/community`],
      {
        queryParams: {
          groupId: this.selectedGroupId,
          tag: this.selectedTag,
        },
      },
    );
  }

  getPostById() {
    this.communityService
      .getCommunityPostById(this.postId)
      .subscribe((result) => {
        this.isDataLoaded = true;
        if (result.Status === ResultStatus.Success) {
          this.postDetail = result.Data;
          if (this.postDetail.Tag) {
            this.splitTags();
          }
          if (this.helperService.isUndefinedOrNullOrEmpty(this.postDetail.PostLink)) {
            this.hasLink = true;
            this.links = this.linkifyService.find(this.postDetail.Description);
          } else {
            this.hasLink = false;
            this.postLink = this.postDetail.PostLink;
          }
          this.getPostComments();
          this.loginUserID = +this.authService.getUserInformation()["ID"];
          this.isDeleteAllow = this.postDetail.CreatedBy === this.loginUserID || this.isModeratorGroupAdmin(this.postDetail.GroupId);
          this.isEditable = this.postDetail.CreatedBy === this.loginUserID ||
            (this.postDetail.PostTypeId === 1 && this.isModeratorGroupAdmin(this.postDetail.GroupId));
          this.isApprovedRejectAllow =
            this.isModeratorGroupAdmin(this.postDetail.GroupId) && this.postDetail.IsHidden === true;
          this.isReportAllow = !this.isModeratorGroupAdmin(this.postDetail.GroupId) && this.postDetail.CreatedBy !== this.loginUserID;
          if (this.communityService.SharedFeedPostComponent.feedPostList.length > 0) {
            if (this.communityService.SharedFeedPostComponent.feedPostList.findIndex((item) => item.ID === this.postDetail.ID) >= 0) {
              this.communityService.SharedFeedPostComponent.feedPostList[
                this.communityService.SharedFeedPostComponent.feedPostList.findIndex((item) => item.ID === this.postDetail.ID)
              ] = this.postDetail;
            }
          }
        } else {
          this.toaterService.error("something went wrong");
        }
      }, (errors) => {
        this.isDataLoaded = true;
      });
  }

  isModeratorGroupAdmin(groupId): boolean {
    if (this.appConfig.SharedComponent.loggedInUserInfo != null) {
      return _.includes(this.appConfig.SharedComponent.loggedInUserInfo["ModeratorGroupId"], groupId);
    }
    return false;
  }

  onToggleOrPlayVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }

  getPostComments() {
    this.communityService.getPostComment(this.postId).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.commentList = result.Data;
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  sendComment() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.commentText)) {
      this.commentText = this.commentText.trim();
    }
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.commentText)) {
      this.communityService
        .createPostComment({ Comment: this.commentText, PostId: this.postId })
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.commentText = "";
            this.resetSize();
            this.getPostById();
            this.getPostComments();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  like(id, islike, likeId) {
    const postData = {
      PostId: id,
      LikedBy: +this.authService.getUserInformation()["ID"],
    };
    if (islike) {
      this.communityService.likeCommunityPost(postData).subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.getPostById();
        } else {
          this.toaterService.error("something went wrong");
        }
      });
    } else {
      this.communityService
        .deleteCommunityPostLike(likeId)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getPostById();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  bookmark(id, isBookmark, bookmarkId) {
    const postData = {
      PostId: id,
      BookmarkedBy: +this.authService.getUserInformation()["ID"],
    };
    if (isBookmark) {
      this.communityService
        .bookmarkCommunityPost(postData)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getPostById();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    } else {
      this.communityService
        .deleteCommunityPostBookmark(bookmarkId)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getPostById();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  deleteCommunityPost() {
    this.communityService
      .deleteCommunityPost(this.postId)
      .subscribe((result) => {
        this.modalService.onHide.unsubscribe();
        this.bsModalRef.hide();
        if (result.Status === ResultStatus.Success) {
          _.remove(this.communityService.SharedFeedPostComponent.feedPostList, (currentObject) => {
            return currentObject.ID === +this.postId;
          });
          this.back();
        } else {
          this.toaterService.error("something went wrong");
        }
      });
  }

  openDeleteConfirmation() {
    this.bsModalRef = this.modalService.show(
      this.deleteMessageTemplate,
      Object.assign({}, { class: "modal-lg" })
    );
  }

  openModalWithComponent(agentID) {
    if (agentID > 0) {
      const initialState = {
        agentId: agentID,
      };

      // this.modalService.config.class = "modal-xl";
      this.bsModalRef = this.modalService.show(AgentDetailComponent, {
        initialState,
        backdrop: 'static',
        class: "modal-xl",
      });
      this.bsModalRef.content.closeBtnName = "Close";
    }
  }

  sharePost(id) {
    this.shareUrl = `${this.window.location.origin}/${this.baseShareUrl}${id}`;
    this.bsModalRef = this.modalService.show(
      this.shareUrlTemplate,
      Object.assign({}, { class: "modal-md" })
    );
    this.communityService.shareComunityPost(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.getPostById();
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  copyToClipboard() {
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", this.shareUrl);
      e.preventDefault();
      document.removeEventListener("copy", null);
    });
    document.execCommand("copy");

    this.toaterService.info("Link Copied");
    this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  ngOnDestroy() {
    if (this.bsModalRef) {
      this.modalService.onHide.unsubscribe();
      this.bsModalRef.hide();
    }
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  editPost(postId, postTypeId) {
    if (postTypeId === 2 || postTypeId === 1) {
      this.bsModalRef = this.modalService.show(ShareUpdateComponent, {
        initialState: { postID: postId },
        class: "modal-lg",
        backdrop: "static",
      });
      this.bsModalRef.content.closeBtnName = "Close";
      this.subscribeModalHideEvent();
    } else {
      this.bsModalRef = this.modalService.show(PostReferralComponent, {
        initialState: { postID: postId },
        class: "modal-lg",
        backdrop: "static",
      });
      this.bsModalRef.content.closeBtnName = "Close";
      this.subscribeModalHideEvent();
    }
  }

  subscribeModalHideEvent() {
    this.modalService.onHide.subscribe((result) => {
      this.getPostById();
    });
  }

  muteCommunityPost(postId, isMute) {
    this.communityService
      .muteCommunityPost(postId, isMute)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          if (isMute) {
            this.toaterService.success("Post is Muted successfully");
          }
          this.getPostById();
        }
      });
  }

  onUp() {
  }

  addComment(startIndex, endIndex, _method) {
  }

  prependItems(startIndex, endIndex) {
  }

  reportPost(postId) {
    this.communityService.reportCommunityPost(postId).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.toaterService.success("Post reported successfully");
        this.getPostById();
        this.bindGlobalFeedPostList();
      }
    });
  }

  bindGlobalFeedPostList() {
    this.selectedGroupId = !this.helperService.isUndefinedOrNullOrEmpty(this.selectedGroupId) ? this.selectedGroupId : 0;
    this.selectedTag = !this.helperService.isUndefinedOrNullOrEmpty(this.selectedTag) ? this.selectedTag : "";
    this.communityService.getCommunityPost(this.selectedGroupId, this.selectedTag, 1).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.communityService.SharedFeedPostComponent.feedPostList = result.Data;
        this.communityService.SharedFeedPostComponent.scrollPosition = 0;
      }
    });
  }

  approvedRejectPost(postId, isApprove) {
    const postData = {
      PostId: postId,
      Comment: "",
      ResolveBy: +this.authService.getUserInformation()["ID"],
      IsApprove: isApprove,
    };
    this.communityService
      .acceptRejectCommunityPost(postData)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          if (isApprove) {
            this.toaterService.success(`Post is approved successfully`);
          } else {
            this.toaterService.success(`Post is rejected successfully`);
          }
          this.getPostById();
        }
      });
  }

  getFileExtension(fileName: string) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(fileName)) {
      const re = /(?:\.([^.]+))?$/;
      const ext = re.exec(fileName)[1];
      return `video/${ext}`;
    }
  }
}
